<template>
  <div class="buybox-factors-panel">
    <div class="panel-header">
      <h3 class="panel-title">
        <span class="title-icon">📊</span>
        Buy Box Factors
      </h3>
    </div>
    <div class="panel-content">
    <div class="factors-grid">
      <div 
        v-for="(factor, index) in factors" 
        :key="index"
        class="factor-item"
      >
        <div class="factor-label">{{ factor.name }}</div>
        <div class="factor-value-row">
          <span class="factor-value">{{ factor.description }}</span>
          <i v-if="factor.status === 'ok'" class="check icon status-ok"></i>
          <i v-else class="times icon status-issue"></i>
        </div>
      </div>
    </div>
    <div class="factor-note">
      <span class="note-icon">💡</span>
      <span class="note-text">
        <strong>Price gap is the primary issue.</strong> Matching or beating $14.99 would likely recover the Buy Box since other factors are equal.
      </span>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuyBoxFactors',
  props: {
    factors: {
      type: Array,
      required: true
    }
  }
}
</script>




// WEBPACK FOOTER //
// BuyBoxFactors.vue?67e7b7c4